import React, { useMemo } from "react";
import { Alert, Container } from "reactstrap";
import { isUndefined } from "lodash";
import { Route as BaseRoute, Redirect, Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useClient, useUserContext } from "./hooks";
import { useOrganisationContext } from "./hooks/useOrganisationContext";
import { AppsClient, PayrollClient, XeroClient, ZatcaClient} from "./services";
import { organisationIdState } from "./atoms";
import { useRecoilValue } from "recoil";
import { withOrganisationContextProvider } from "./contexts/OrganisationContext";

import { useRecoilState } from "recoil";
import { showHeaderState } from './atoms'
import {SelectionComponents} from "./pages";
import { check_permissions } from './Helpers'



const Warning = ({ children, ...props }) => (
  <Alert color="warning" className="small text-center my-2" {...props}>
    <span className="fa fa-exclamation-circle mr-2" />
    <Trans>{children}</Trans>
  </Alert>
);

export const Route = withOrganisationContextProvider(
  ({
    checkTrial,
    checkUser,
    checkSuspended,
    checkOrganisation,
    test,
    noContainer,
    fluid,
    component: Component,
    componentProps,
    ...props
  }) => {
    const { user, permissions} = useUserContext();
    const { selectedOrganisation } = useOrganisationContext();
    const organisationId = useRecoilValue(organisationIdState);
    const client = useClient();
    const [xero, payroll] = useMemo(
      () => [XeroClient(), PayrollClient(), AppsClient(), ZatcaClient()],
      [organisationId]
    );

    const { t, i18n } = useTranslation();

    const [showHeader, setShowHeader] = useRecoilState(showHeaderState);


    React.useEffect(() => {
      const isPathWithoutHeader = ['/home', '/wp-connect', '/e-invoicing', '/authorization/success', '/allusers', '/settings', '/applications'].includes(window.location.pathname);
      setShowHeader(!isPathWithoutHeader);
    }, [window.location.pathname]);

    if (checkUser && !user) {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      );
    }

    /*
     * Route: /home => show SelectionComponents if user Log in
     */
    if(window.location.pathname==='/home'){
      return (<SelectionComponents/>);
    }

    const problemBase = (children) => <Container fluid>{children}</Container>;

    if (!check_permissions(permissions, props.access, props.func))
      return problemBase(
        <Warning><Trans>You are not authorized to view this page</Trans></Warning>
      );
        
    if (!isUndefined(test) && !test)
      return problemBase(
        <Warning><Trans>You are not authorized to view this page</Trans></Warning>
      );

    // if (checkTrial && user?.trial_ended) {
    //   return problemBase(
    //     <Warning>
    //       Your trial has expired, please contact us at{" "}
    //       <strong>xero@wpholding.com</strong> to arrange payment and activate
    //       membership
    //     </Warning>
    //   );
    // }

    if (user?.suspended) {
      return problemBase(
        <Alert color="warning" className="text-center mt-2">
          <Trans>
            <span className="fa fa-exclamation-circle mr-1" /> Your account has
            been suspended. Please contact with support team.
          </Trans>
        </Alert>
      );
    }

    if (checkOrganisation) {
      if (!selectedOrganisation) {
        return problemBase(<Warning>Please select an Organisation</Warning>);
      } else if (selectedOrganisation.status === "NOT_CONNECTED") {
        return problemBase(
          <Warning>Selected Organisation is not connected to Xero</Warning>
        );
      }
    }

    const container = (children) =>
      noContainer ? children : <div className={fluid ? 'container-fluid' : "container-xl"}>{children}</div>;

    

    return (
      <BaseRoute
        render={(props) => {
          const key = checkOrganisation ? selectedOrganisation.id : 0;
          return container(
            <Component
              {...props}
              t={t}
              i18n={i18n}
              selectedOrganisation={selectedOrganisation}
              client={client}
              xero={xero}
              key={key}
              payroll={payroll}
              {...componentProps}
            />
          );
        }}
        {...props}
      />
    );
  }
);
